module.exports = __webpack_public_path__ + "step2_child_to_parent_son.a5882303.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step2_child_to_parent_son.jpg
// module id = AYBQ
// module chunks = 0